import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';

export const LatestBuildContext = React.createContext<IPreloadCacheContext<number>>(undefined as any);
